import React from "react";
import { Container } from "../../../../components";
import classnames from "classnames";
import PAGES from "../../../../../../constants/pages";
import TEXT from "../../../text-consts";
import BackLink from "../../atoms/BackLink/BackLink";
import PersonalDetailsContinueButton from "../../organisms/PersonalDetailsContinueButton/PersonalDetailsContinueButton";
interface ContinueButtonProps {
    path: string;
}

const ContinueButton: React.FC<ContinueButtonProps> = ({ path }) => {
    switch (path) {
        case PAGES.PREPAID.REGISTRATION.URL:
            return <PersonalDetailsContinueButton />;
        default:
            return null;
    }
};

interface BackButtonProps {
    path: string;
}

const BackButton: React.FC<BackButtonProps> = ({ path = "" }) => {
    let href = "";
    let text: string = TEXT.BUTTON.BACK;

    switch (true) {
        case path === PAGES.PREPAID.REGISTRATION.URL:
            href = "/mobilabonnement/kontantkort/";
            text = TEXT.BUTTON.HOMEPAGE;
            break;
        case path === PAGES.PREPAID.REGISTRATION.RECEIPT.URL:
            href = "/mobilabonnement/kontantkort/";
            text = TEXT.BUTTON.HOMEPAGE;
            break;
        case path.includes(PAGES.PREPAID.REFILL.RECEIPT.URL):
            href = "/mobilabonnement/kontantkort/lade";
            text = TEXT.BUTTON.BACK_TO_HOMEPAGE;
            break;
    }

    return <BackLink href={href} text={text} />;
};

interface ContinueSectionProps {
    className?: string;
    path: string;
}

const ContinueSection: React.FC<ContinueSectionProps> = ({ className = "", path }) => (
    <Container
        className={classnames("prepaid-reg-page--space-between", {
            [className]: className,
        })}
        size="small"
        noMargin
    >
        <BackButton path={path} />
        <div className="prepaid-reg-page__continue-button-container">
            <ContinueButton path={path} />
        </div>
    </Container>
);

export default ContinueSection;
